import { Box } from '@mantine/core'
import { useTranslation } from 'react-i18next'

import { useSectionPaths } from 'hooks/navigation/useSectionPaths.hooks'

import { PageHeader } from 'components/layout/PageHeader'

import { ManageCoworkersPage } from '../ManageCoworkersPage'

export const TeamleadLandingPage = () => {
  const { t } = useTranslation()
  const { specialPath } = useSectionPaths()

  const backHref = specialPath ? `${specialPath}/users` : undefined
  return (
    <Box data-testid="page-manage-coworkers">
      <PageHeader
        backHref={backHref}
        // TODO: Replace the title with the team name + flag?
        title={t('features.coworker.coworkers-overview.title')}
      />
      <ManageCoworkersPage />
    </Box>
  )
}
